import React, { useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import styled from 'styled-components';
import Header from './components/Header';
import PageFooter from './components/PageFooter';
import RecruiterPortfolio from './components/RecruiterPortfolio';
import AboutPage from './components/AboutPage';
import BlogPage from './components/BlogPage';
import BlogPost from './components/BlogPost';
import WayfairCaseStudy from './components/case-studies/WayfairCaseStudy';
import FreebitesCaseStudy from './components/case-studies/FreebitesCaseStudy';
import AsciiArtLoadingCaseStudy from './components/case-studies/AsciiArtLoadingCaseStudy';
import MassCaseStudy from './components/case-studies/MassCaseStudy';
import OfficeMinutesCaseStudy from './components/case-studies/OfficeMinutesCaseStudy';
import WayfairAiAssistantCaseStudy from './components/case-studies/WayfairAiAssistantCaseStudy';
import PomodoroCaseStudy from './components/case-studies/PomodoroCaseStudy';
import PersonalPortfolioCaseStudy from './components/case-studies/PersonalPortfolioCaseStudy';
import PasswordGate from './components/PasswordGate';
import { markIntroSeenOnLeave } from './components/Banner';
import { bindClickSound } from './clickSound';

const Frame = styled.div`
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  background: var(--bg);
`;

const RouteSlot = styled.div`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
`;

const showHeaderOn = (pathname) =>
  pathname === '/' ||
  pathname === '/work' ||
  pathname === '/blog' ||
  pathname === '/about';

const showFooterOn = (pathname) => pathname === '/about';

function AppRoutes() {
  const location = useLocation();
  const entryPath = useRef(window.location.pathname);
  markIntroSeenOnLeave(entryPath.current, location.pathname);

  useEffect(() => {
    const before = window.scrollY;
    const behavior = getComputedStyle(document.documentElement).scrollBehavior;
    // #region agent log
    fetch('http://127.0.0.1:7723/ingest/d7b880e8-87ce-4390-95ff-712f6f14be97',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'4acb28'},body:JSON.stringify({sessionId:'4acb28',runId:'post-fix',hypothesisId:'D',location:'App.js:scrollTo',message:'route scroll reset',data:{path:location.pathname,scrollYBefore:before,scrollBehavior:behavior,htmlOverflowY:getComputedStyle(document.documentElement).overflowY},timestamp:Date.now()})}).catch(()=>{});
    // #endregion
    window.scrollTo(0, 0);
    requestAnimationFrame(() => {
      // #region agent log
      fetch('http://127.0.0.1:7723/ingest/d7b880e8-87ce-4390-95ff-712f6f14be97',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'4acb28'},body:JSON.stringify({sessionId:'4acb28',runId:'post-fix',hypothesisId:'D',location:'App.js:scrollTo:raf',message:'scrollY after reset frame',data:{path:location.pathname,scrollY:window.scrollY},timestamp:Date.now()})}).catch(()=>{});
      // #endregion
    });
  }, [location.pathname]);

  return (
    <Frame>
      {showHeaderOn(location.pathname) && <Header />}
      <RouteSlot>
        <AnimatePresence mode="wait">
          <Routes>
          <Route
            path="/"
            element={
              <PasswordGate>
                <RecruiterPortfolio />
              </PasswordGate>
            }
          />
          <Route path="/work" element={<Navigate to="/" replace />} />
          <Route path="/recruiter" element={<Navigate to="/" replace />} />
          <Route path="/gallery" element={<Navigate to="/about" replace />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/playground" element={<Navigate to="/about" replace />} />
          <Route path="/case-studies/wayfair-ai-assistant" element={<WayfairAiAssistantCaseStudy />} />
          <Route path="/case-studies/wayfair" element={<WayfairCaseStudy />} />
          <Route path="/case-studies/freebites" element={<FreebitesCaseStudy />} />
          <Route path="/case-studies/ascii-art-loading" element={<AsciiArtLoadingCaseStudy />} />
          <Route path="/case-studies/mass" element={<MassCaseStudy />} />
          <Route path="/case-studies/officeminutes" element={<OfficeMinutesCaseStudy />} />
          <Route path="/case-studies/pomodoro" element={<PomodoroCaseStudy />} />
          <Route path="/case-studies/personal-portfolio" element={<PersonalPortfolioCaseStudy />} />
          </Routes>
        </AnimatePresence>
      </RouteSlot>
      {showFooterOn(location.pathname) && <PageFooter />}
    </Frame>
  );
}

function App() {
  useEffect(() => bindClickSound(), []);

  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;
